import { useQuery } from '@tanstack/react-query';

import { getAdminStats, AdminStatsResponse } from '@/services/api/admin';

export const ADMIN_STATS_QUERY_KEY = ['admin', 'stats'];

export const useAdminStats = () => {
  const query = useQuery<AdminStatsResponse>({
    queryKey: ADMIN_STATS_QUERY_KEY,
    queryFn: getAdminStats,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });

  return {
    stats: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
